'use client';

/**
 * SidebarWidthContext
 *
 * Provides the current total sidebar width to AppNavBar and PortalLayout
 * for offset calculations. In 'rail' mode, width is 70 (rail-only) or
 * 270 (rail + panel). In 'classic' mode, width is the configured drawer width.
 *
 * @see PR #856 — Navigation & Layout Redesign
 */

import { createContext, type ReactNode, useContext, useMemo } from 'react';

export interface SidebarWidthContextValue {
  /** Current total sidebar width in pixels */
  sidebarWidth: number;
}

const SidebarWidthContext = createContext<SidebarWidthContextValue>({ sidebarWidth: 240 });

export interface SidebarWidthProviderProps {
  sidebarWidth: number;
  children: ReactNode;
}

export function SidebarWidthProvider({ sidebarWidth, children }: SidebarWidthProviderProps) {
  const value = useMemo(() => ({ sidebarWidth }), [sidebarWidth]);
  return <SidebarWidthContext.Provider value={value}>{children}</SidebarWidthContext.Provider>;
}

export function useSidebarWidth(): SidebarWidthContextValue {
  return useContext(SidebarWidthContext);
}
